import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SendMessageIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M1.33998 14 15.3333 8 1.33998 2l-.00667 4.66667L11.3333 8 1.33331 9.33333 1.33998 14Z" />
  </Icon>
);

export default memo(SendMessageIcon);
